import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'
import cookies from '@/utils/cookies'

const API_URL = import.meta.env.VITE_API_BASE_URL

if (!API_URL) {
  console.error('REACT_APP_API_BASE_URL= is not defined in environment')
}

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 100000,
})

axiosInstance.interceptors.request.use(
  (
    config: InternalAxiosRequestConfig
  ): InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig> => {
    const accessToken = cookies.get('ai_tk')

    // Ensure the headers object exists
    config.headers = config.headers ?? {} // Initialize headers if undefined

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }
    return config
  },
  (error: AxiosError): Promise<AxiosError> => {
    if (error.response && error.response.status === 401) {
      window.location.replace('/login')
    }
    return Promise.reject(error)
  }
)

export { axiosInstance as axios }
